import React from "react";
import ImageOne from "../assets/images/sir.jpg";
import HrImage from "../assets/images/AwardsImages_MAM/HR.jpg";
import { Link } from "react-router-dom";

const FounderHero = () => {
  return (
    <>
      <div className="px-6 relative">
        <h1 className="text-4xl mb-10 text-theme-blue text-center font-bold">
          Our Founders
        </h1>
        <div className="w-full mb-10 px-4 sm:px-6 md:px-8 lg:px-14">
          <h1 className="text-gray-400 font-light text-xl sm:text-2xl md:text-3xl lg:text-2xl">
            Started in 2020, we at Scode Software Solutions aim to transform
            tier-3 cities into thriving technology hubs by delivering robust and
            cost-effective digital services.
          </h1>
        </div>

        {/* <div className="w-full sm:w-11/12 md:w-10/12 lg:w-10/12 mb-10 px-4 md:ps-14">
          <h1 className="text-gray-400 font-light  sm:text-2xl md:text-2xl">
            Started in 2020, we at Scode Software Solutions aim to transform
            tier-3 cities into thriving
          </h1>
          <h1 className="text-gray-400 font-light  sm:text-2xl md:text-2xl">
            technology hubs by delivering robust and cost-effective digital
            services.
          </h1>
        </div> */}

        {/* Card section */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-2 max-w-3xl mx-auto px-4 cursor-pointer">
          {/* Card 1 */}
          <Link
            to="/founder-person-one"
            className="flex flex-col items-center p-10 px-5 rounded-[50px] shadow-lg border border-light-theme-purple transition-transform duration-300 hover:scale-105"
          >
            <div className="relative w-[150px] h-[150px] mt-4">
              <img
                src={ImageOne}
                alt="Card image"
                className="w-full h-full object-cover rounded-full border-4 border-transparent"
              />

              {/* Half-circle white overlay */}
              <div className="absolute bottom-0 right-0 w-full h-1/2 rounded-b-full border-b-4 border-blue-700 z-10 pointer-events-none"></div>
            </div>

            <div className="pl-5">
              <h2 className="text-theme-purple mt-6 text-[23px] text-center font-semibold">
                Tyson Vignesh V
              </h2>
              <p className="text-theme-purple mt-6 text-[18px] text-center">
                Founder & Managing Director
              </p>
            </div>
          </Link>

          {/* Card 2 */}
          <Link
            to="/founder-person-two"
            className="flex flex-col items-center p-8 px-5 rounded-[50px] shadow-lg border border-light-theme-purple transition-transform duration-300 hover:scale-105"
          >
            <div className="relative w-[150px] h-[150px] mt-4">
              <img
                src={HrImage}
                alt="Card image"
                className="w-full h-full object-cover rounded-full border-4 border-transparent"
              />

              {/* Half-circle white overlay */}
              <div className="absolute bottom-0 right-0 w-full h-1/2 rounded-b-full border-b-4 border-blue-700 z-10 pointer-events-none"></div>
            </div>

            <div className="pl-5">
              <h2 className="text-theme-purple mt-6 text-[23px] text-center font-semibold">
                Catherine Sangeetha A
              </h2>
              <p className="text-theme-purple mt-6 text-[18px] text-center">
                Co-Founder & Human Resources
              </p>
            </div>
          </Link>
        </div>
      </div>

      {/* Design  */}
      <div className="absolute top-60 left-0 w-full h-[180px] z-0 overflow-hidden hidden lg:block">
        <div className="w-full h-full bg-gradient-to-l from-blue-900 via-blue-300 to-transparent rounded-b-[10%] opacity-35 transform rotate-12"></div>
      </div>
    </>
  );
};

export default FounderHero;
